export default __webpack_public_path__ + "static/placeholder-4-3-30bc7ed16f440c07fce226335b22c1f7.png";